import _assign from "object-assign";

var _icons;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Icon } from '@jpmuitk/icon';
import State from './State';
var icons = (_icons = {}, _defineProperty(_icons, State.error, 'error'), _defineProperty(_icons, State.success, 'tick'), _defineProperty(_icons, State.warning, 'warning'), _icons);
export default (function (state) {
  var StateIcon = function StateIcon(props) {
    return icons[state] ? /*#__PURE__*/React.createElement(Icon, _assign({
      name: icons[state]
    }, props)) : null;
  };

  return state ? StateIcon : null;
});